import PhotoSwipeLightbox from './photoswipe-lightbox.esm'

const lightbox = new PhotoSwipeLightbox({
	gallery: '.pswp-gallery',
	children: '.box-image-hover',
	pswpModule: () => import('./photoswipe.esm'),
  showHideAnimationType: 'none',
});

lightbox.init();
